import React from 'react';
import { ResponsiveBullet } from '@nivo/bullet';
import { scaleLinear } from 'd3-scale';
import {stringMixin} from "../../utils/strings";

const NivoBullet = ({ min, max, target, value, title }) => {
  const data = [
    {
      id: title,
      ranges: [max],
      measures: [value],
      markers: [target],
    },
  ];

  const blueGradient = scaleLinear()
    .domain([0, 1])
    .range(['#0093FF', '#000'])
    .interpolate((a, b) => (t) => {
      const color = scaleLinear().domain([0, 1]).range([a, b])(t);
      return color;
    });

  return (
    <div style={{ height: '100%', width: '100%', position: 'relative', borderRadius: '8px', overflow: 'hidden' }}>
      <ResponsiveBullet
        data={data}
        margin={{ top: 10, right: 10, bottom: 10, left: 0 }}
        spacing={0}
        titleAlign="middle"
        titleOffsetX={-40}
        rangeColors={[blueGradient(0)]}
        measureColors={['#032144']}
        markerColors={['#DEF1F9']}
        rangeBorderRadius={'20px'}
        measureBorderRadius={'20px'}
        markerWidth={2}
        animate={false}
        axisPosition="after"
        titlePosition="before"
        theme={{
          axis: {
            domain: {
              line: {
                strokeWidth: 0,
              },
            },
            ticks: {
              line: {
                strokeWidth: 0,
              },
              text: {
                fill: 'red',
              },
            },
          },
          tooltip: {
            container: {
              background: '#fff',
              color: 'red',
              fontSize: 12,
              borderRadius: 4,
              boxShadow: '0 1px 2px rgba(0,0,0,0.25)',
            },
          },
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '27.5%',
          left: '15px',
          transform: 'translateY(-50%)',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '12px',
          textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
        }}
      >
        {`${title}: ${value > 1e6 ? stringMixin.largeNumber(value) : value.toFixed(2)} / ${max > 1e6 ? stringMixin.largeNumber(max) : max.toFixed(2)}`}
      </div>
    </div>
  );
};

export default NivoBullet;